<template>
    <div class="announcement">
        <div class="announcement-text">
            <img class="announcement-decoration" src="~@/assets/sword_left.png" />
            <span class="announcement-title">
                <slot name="title">
                    {{ title || 'Title' }}
                </slot>
            </span>
            <img class="announcement-decoration" src="~@/assets/sword_right.png" />
            <button class="btn btn-textual dismiss-btn" @click="$emit('dismiss')">
                <fa-icon class="announcement-btn-icon" icon="times" />
            </button>
        </div>
        <div class="announcement-content">
            <template v-if="$slots.default">
                <slot />
            </template>
            <div
                v-else
                class="announcement-content-html"
                v-html="content || 'Content'"
            />
        </div>
        <div class="announcement-footer" v-if="$slots.footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Announcement',
    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .announcement {
        background: white;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        position: relative;
        border-radius: 4px;
        padding: 15px 10px;


        > * {
            align-self: center;
        }

        .announcement-footer {
            display: flex;
            font-size: .85rem;
        }

        .announcement-decoration {
            height: auto;
            max-height: 25px;
            max-width: 25px;
            width: auto;
            margin: 0 5px;
        }

        .announcement-text {
			width: 100%;
            display: flex;
            font-family: 'RobotoSlab', 'Avenir', Helvetica, Arial, sans-serif;
            text-align: left;
            font-size: 1rem;
            position: relative;
            justify-content: center;
            text-align: center;
            max-width: 85%;

            > * {
                align-self: center;
            }
        }

        .announcement-title {
            display: inline-flex;
            justify-content: center;
			font-weight: bold;
        }

        .announcement-content {
			margin-top: 15px;
            display: flex;
            justify-content: space-evenly;
            width: 100%;
            gap: 20px;
            flex-direction: column;
        }

        .announcement-content-html {
            width: 100%;
        }

        .sub-caption {
            font-size: .75rem;
            margin: 7px 0 3px 0;
            max-width: 450px;
        }

        .dismiss-btn {
            font-size: .8rem;
            white-space: nowrap;
            position: absolute;
            left: calc(100% + 15px);
            top: 50%;
            transform: translateY(-50%);

            .announcement-btn-icon {
                margin-right: 5px;
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .announcement {
            .announcement-text {
                font-size: 1.2rem;
            }
        }
    }

    @media only screen and (min-width: $screen-md) {

        .announcement {
            align-items: center;
            justify-content: space-between;
            padding: 15px 25px;

            .announcement-content {
                flex-direction: row;
                align-items: center;
            }
        }
    }
</style>
